import React, { useEffect, useState } from 'react';

import { IHoleResult } from '../../../../../../../../../store/admin/holeResults/store';

import { CTPTAbleSubRow } from './CTPTAbleSubRow';
import { CTPTAbleExpandableSubRow } from './CTPTAbleExpandableSubRow';
import {
  ISkinsResults,
  useAssignResultsState
} from '../../../../../../Common/AssignResults/Context/AssignResults.context';
import { getCTPHoleWinner } from '../../../../../../Common/AssignResults/Context/Utils/getCTPHoleWinner';

interface ICTPTableRow {
  hole: string;
  index: number;
  ctpResults: ISkinsResults;
  roundId: number;
}

export const CTPTableRow = (props: ICTPTableRow) => {
  const { hole, index, ctpResults, roundId } = props;
  const { selectedCombination } = useAssignResultsState();

  const [collapsedRow, setCollapsedRow] = useState<number>();

  const expandRow = (rowIndex: number) => () =>
    setCollapsedRow(collapsedRow === rowIndex ? undefined : rowIndex);

  const [ctpHoleWinner, setctpHoleWinner] = useState<IHoleResult>();

  useEffect(() => {
    if (selectedCombination) {
      const ctpWinner = getCTPHoleWinner(
        ctpResults[Number(hole)],
        selectedCombination.format.considerFlights,
        selectedCombination.format.adjustedHandicap
      );

      if (ctpWinner) {
        setctpHoleWinner(ctpWinner);
      }
    }
  }, [ctpResults, hole, selectedCombination]);

  return selectedCombination ? (
    <>
      <CTPTAbleSubRow
        roundId={roundId}
        holeResult={ctpHoleWinner}
        hole={hole}
        index={index}
        expandRow={expandRow}
      />

      <CTPTAbleExpandableSubRow
        ctpResults={ctpResults}
        hole={hole}
        index={index}
        roundId={roundId}
        expandRow={expandRow}
        collapsedRow={collapsedRow}
      />
    </>
  ) : (
    <></>
  );
};

export default CTPTAbleExpandableSubRow;
